import ModalUniversal from './modal-universal';

export default ModalUniversal;
